import React from 'react'
import { LayoutBand, Row, Paragraph } from '@fs/zion-ui'
import { useUser } from '@fs/zion-user'
// import { useTranslation } from 'react-i18next'
import { useFeatureFlag } from '@fs/zion-flags'
import { css } from '@emotion/core'
import { useRegistrationContext } from '../../providers'
import OnlineEventButton from '../../components/registration/components/OnlineEventButton'
import InPersonEventButton from '../../components/registration/components/InPersonEventButton'
import { OnlineScheduleButton, InPersonScheduleButton } from '../buttons/ScheduleButton'
import { FLAGS, flavors } from '../../config'

const useRegistrationText = (signedIn, subscriptions) => {
  // const [t] = useTranslation()
  // TODO: add tranlsation keys once Event team decides what the correct messaging should be.
  const registrationBannerFlag = useFeatureFlag(FLAGS.REGISTRATION_BANNER)
  if (!registrationBannerFlag.isOn) {
    return null
  }

  //
  let heading = 'Not Signed In'
  if (signedIn) {
    heading = 'Signed In'
    const registeredBoth = subscriptions.onlineEvent && subscriptions.inPersonEvent
    const onlyOnline = subscriptions.onlineEvent && !subscriptions.inPersonEvent
    const onlyInPerson = !subscriptions.onlineEvent && subscriptions.inPersonEvent
    if (registeredBoth) {
      heading = 'Registered In Person and Online'
    }
    if (onlyOnline) {
      heading = 'Registered Online Only'
    }
    if (onlyInPerson) {
      heading = 'Registered In Person Only'
    }
  }

  return heading
}

const bannerCss = css`
  background: var(--gradient);
`
export default function RegistrationBanner({ flavor = 'seafoam' }) {
  const { signedIn } = useUser()
  const { subscriptions } = useRegistrationContext()
  const heading = useRegistrationText(signedIn, subscriptions)
  const registrationBannerFlag = useFeatureFlag(FLAGS.REGISTRATION_BANNER)

  return registrationBannerFlag.isOn ? (
    <LayoutBand css={bannerCss} style={{ '--gradient': flavors[flavor].gradient }} marginY="xxs">
      <Row alignY="middle" alignX="center" guttersY="nano" wrap>
        <Paragraph as="strong" size="md">
          {heading}
        </Paragraph>
        <div growX />
        <Row>
          {!subscriptions.onlineEvent && <OnlineEventButton emphasis="medium" />}
          {subscriptions.onlineEvent && <OnlineScheduleButton emphasis="medium" />}
          {!subscriptions.inPersonEvent && <InPersonEventButton emphasis="medium" />}
          {subscriptions.inPersonEvent && <InPersonScheduleButton emphasis="medium" />}
        </Row>
      </Row>
    </LayoutBand>
  ) : null
}
